export default __webpack_public_path__ + "static/bento-3p12-e13d72d43a88892f7352a148e0089000.png";